import { useMemo, useState, } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useCustomAddNumberMutation } from '@/api/enterance';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { clearPlateNumberAddParams, selectPlateNumberAddParams, selectShowPlateNumberAdd } from "./modalsSlice";

const PlateNumberAddModal = () => {
  const show = useSelector(selectShowPlateNumberAdd)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const modalParams = useSelector(selectPlateNumberAddParams)
  const [plateNumber, setPlateNumber] = useState('');

  const [ fetchCreate, { 
    isLoading, 
    isError,
    isSuccess,
    reset 
  }] = useCustomAddNumberMutation();
  
  const handleClose = () => {
    setPlateNumber('')
    reset();
    dispatch(clearPlateNumberAddParams());
  }

  const handleCreate = async () => {
    try {
      await fetchCreate({
        plateNumber,
        channelId: modalParams?.channelId
      }).unwrap()
    } catch (err) {
      console.log(err)
    }
  }
  const statusAlert = useMemo(() => (
    isSuccess 
      ? { severity: 'success', message: t('number_added_to_list') }
      : isError
      ? { severity: 'error', message: t('error_adding_number') }
      : undefined
  ), [isError, isSuccess, t])
  return (
    <Dialog 
      open={show}
      onClose={handleClose}
    >
      <DialogTitle>{t('manual_number_entry')}</DialogTitle>
      <DialogContent>
        {
          statusAlert && 
          <Alert
            xs={{
              mb: 2,
            }}
            variant="outlined"
            severity={statusAlert.severity}
          >
            { t(statusAlert.message) }
          </Alert>
        }
        <TextField
          autoFocus
          required
          margin="dense"
          id="plateNumber"
          name="plateNumber"
          label={t('enter_number')}
          type="text"
          fullWidth
          variant="standard"
          value={plateNumber}
          onChange={({ target }) => setPlateNumber(target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={handleClose}
        >
          { t('close') }
        </Button>
        {
          !isSuccess &&
          <Button
            loading={isLoading}
            type="submit"
            disabled={plateNumber.length < 3 || isLoading}
            onClick={handleCreate}
          >
            { t('add') }
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
}

export default PlateNumberAddModal;